import { Modal } from '@heroui/react'
import { useTranslation } from 'react-i18next'

import { WarehouseArticleForm } from './WarehouseArticleForm'

interface WarehouseArticleDialogProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  articleId?: string;
}

export function WarehouseArticleDialog({ isOpen, onOpenChange, articleId }: WarehouseArticleDialogProps) {
  const { t } = useTranslation()

  const closeModal = () => onOpenChange(false)

  return (
    <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
      <Modal.Backdrop variant="blur" className="bg-zinc-950/40" isDismissable>
        <Modal.Container placement="center">
          <Modal.Dialog>
            <Modal.CloseTrigger />
            <Modal.Header>
              <Modal.Heading className="font-bold">
                {articleId ? t('warehouse.edit_article') : t('warehouse.new_article')}
              </Modal.Heading>
            </Modal.Header>
            <Modal.Body className={'mt-4'}>
              <WarehouseArticleForm
                key={articleId || 'new'}
                articleId={articleId}
                onSuccess={closeModal}
                onCancel={closeModal}
              />
            </Modal.Body>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </Modal>
  )
}
